// import axios from 'axios';

// const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

// const API = axios.create({
//   baseURL: BASE_URL,
//   timeout: 30000,
//   headers: { 'Content-Type': 'application/json' },
// });

// // ── Attach access token to every request ──
// API.interceptors.request.use((config) => {
//   const token = localStorage.getItem('accessToken');
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// // ── On 401: silently refresh token, retry, THEN redirect if refresh fails ──
// let isRefreshing = false;
// let failedQueue  = [];

// const processQueue = (error, token = null) => {
//   failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
//   failedQueue = [];
// };

// const clearAndRedirect = () => {
//   localStorage.removeItem('accessToken');
//   localStorage.removeItem('refreshToken');
//   window.location.href = '/login';
// };

// API.interceptors.response.use(
//   (res) => res,
//   async (err) => {
//     const original = err.config;

//     // Only intercept 401s that haven't already been retried
//     if (err.response?.status !== 401 || original._retry) {
//       return Promise.reject(err);
//     }

//     // Never retry auth endpoints themselves
//     if (original.url?.includes('/auth/')) {
//       clearAndRedirect();
//       return Promise.reject(err);
//     }

//     // If a refresh is already in progress, queue this request
//     if (isRefreshing) {
//       return new Promise((resolve, reject) => {
//         failedQueue.push({ resolve, reject });
//       }).then((token) => {
//         original.headers.Authorization = `Bearer ${token}`;
//         return API(original);
//       });
//     }

//     original._retry = true;
//     isRefreshing    = true;

//     const refreshToken = localStorage.getItem('refreshToken');

//     if (!refreshToken) {
//       clearAndRedirect();
//       return Promise.reject(err);
//     }

//     try {
//       const res = await axios.post(`${BASE_URL}/auth/refresh-token`, { refreshToken });
//       const newAccess  = res.data?.data?.accessToken;
//       const newRefresh = res.data?.data?.refreshToken;

//       if (!newAccess) throw new Error('No token returned');

//       localStorage.setItem('accessToken', newAccess);
//       if (newRefresh) localStorage.setItem('refreshToken', newRefresh);

//       API.defaults.headers.common.Authorization = `Bearer ${newAccess}`;
//       original.headers.Authorization            = `Bearer ${newAccess}`;

//       processQueue(null, newAccess);
//       return API(original); // retry the original request with new token
//     } catch (refreshErr) {
//       processQueue(refreshErr, null);
//       clearAndRedirect();
//       return Promise.reject(refreshErr);
//     } finally {
//       isRefreshing = false;
//     }
//   }
// );

// export default API;





import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

// ── In-memory token store — never touches localStorage ──────
let _accessToken = null;

export const setAccessTokenInMemory = (token) => { _accessToken = token; };
export const getAccessTokenInMemory = ()        => _accessToken;

const API = axios.create({
  baseURL:         BASE_URL,
  timeout:         30000,
  withCredentials: true,   // send httpOnly cookies on every request
  headers:         { 'Content-Type': 'application/json' },
});

// ── Attach in-memory access token to every request ──────────
API.interceptors.request.use((config) => {
  if (_accessToken) config.headers.Authorization = `Bearer ${_accessToken}`;
  return config;
});

// ── On 401: silently refresh via cookie, retry ──────────────
let isRefreshing = false;
let failedQueue  = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  failedQueue = [];
};

const clearAndRedirect = () => {
  _accessToken = null;
  window.location.href = '/login';
};

API.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;

    if (err.response?.status !== 401 || original._retry) return Promise.reject(err);
    // Never redirect from auth endpoints — let callers handle it
    if (original.url?.includes('/auth/')) return Promise.reject(err);

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then((token) => {
        original.headers.Authorization = `Bearer ${token}`;
        return API(original);
      });
    }

    original._retry = true;
    isRefreshing    = true;

    try {
      // Cookie is sent automatically — no need to pass refreshToken in body
      const res        = await axios.post(`${BASE_URL}/auth/refresh-token`, {}, { withCredentials: true });
      const newAccess  = res.data?.data?.accessToken;
      if (!newAccess) throw new Error('No token returned');

      _accessToken = newAccess;
      API.defaults.headers.common.Authorization = `Bearer ${newAccess}`;
      original.headers.Authorization            = `Bearer ${newAccess}`;

      processQueue(null, newAccess);
      return API(original);
    } catch (refreshErr) {
      processQueue(refreshErr, null);
      clearAndRedirect();
      return Promise.reject(refreshErr);
    } finally {
      isRefreshing = false;
    }
  }
);

export default API;